export const eventDetails = {
  1: {
    title: "La Fiesta -4.0",
    subtitle: "A Celebration of Differently-Abled Children",
    details: {
      date: "18th April, 2025",
      venue: "Main Auditorium, Thapar Institute",
      category: "Inclusion",
      semester: "Even Semester, Academic Session 2024–25",
      participants: "42 children from NGOs + Thapar University students",
      team: "53 members"
    },
    about: "La Fiesta was much more than just a celebration — it was a heartfelt initiative dedicated to bringing smiles to the faces of children who are uniquely beautiful in their own ways. The event created a nurturing and joyful space where differently-abled children were encouraged to express themselves freely, and were celebrated with warmth, support, and enthusiasm.\n\nChildren from various schools and NGOs across Patiala were invited to participate in a variety of fun competitions and creative activities. The Main Auditorium was transformed into a vibrant, colourful world of happiness — decorated with bright colours, music, games, and lively stalls that gave every child a sense of wonder and belonging.",
    highlights: [
      {
        title: "Creative Competitions & Activities",
        content: "Children participated in drawing, clay modelling, singing, and dancing competitions. Each child's talent was met with genuine cheers and encouragement from the audience, creating a lively and positive atmosphere where no child felt left behind."
      },
      {
        title: "Performances",
        content: "Performances were delivered by members of Youth United, Thapar University students, and children from various NGOs — ensuring the spirit of celebration was shared and enjoyed by all present."
      },
      {
        title: "Awards & Recognition",
        content: "A drawing and clay modelling competition was organized for the children, and 5 winners were awarded with stationery items and goodies. Every participating child received prizes, snacks, and heartfelt applause, making the experience truly memorable."
      }
    ],
    purpose: "Beyond the festivities, La Fiesta carried a deeper purpose — to boost the confidence of differently-abled children, spread compassion, and promote the true power of inclusion. By creating a space where every individual felt valued, La Fiesta helped break societal stereotypes and brought people together in a meaningful way.",
    impact: [
      "Children expressed themselves freely through art, music, and performance in a supportive environment",
      "The Main Auditorium radiated energy, music, and colourful decorations, creating a lively and happy atmosphere",
      "Every performance was celebrated with enthusiasm, helping children build confidence and feel a sense of belonging",
      "La Fiesta sparked important conversations about inclusion, acceptance, and breaking stereotypes",
      "Through laughter, performances, and shared moments of joy, it inspired everyone to be more compassionate"
    ]
  },
  2: {
    title: "Society Fair",
    subtitle: "Welcoming the Batch of 2029",
    details: {
      date: "24th August, 2025",
      venue: "Frosh Society Fair, Thapar Campus",
      category: "Outreach & Recruitment",
      semester: "Odd Semester, Academic Year 2025–26",
      target: "Batch of 2029 (Freshers)",
      team: "10 members"
    },
    about: "On 24th August 2025, Youth United participated in the Society Fair, a flagship event for freshers joining Thapar Institute. The society's goal was to engage incoming students, showcase its vibrant culture, and attract passionate new members. The event was thoughtfully designed to blend creativity, interaction, and promotion of Youth United's values.",
    highlights: [
      {
        title: "Creative Preparations",
        content: "The team held a creativity session where members designed key elements for their stall: A prominent Youth United banner, mini informational cards, an Old Events Board, and a custom dice game with an interactive \"Pick One and Leave One\" board."
      },
      {
        title: "Event Day Highlights",
        content: "The Youth United stall was strategically placed in a high-traffic area. The game station became a focal point — attendees were drawn in by the playful dice challenge and the thought-provoking \"Pick One and Leave One\" board, facilitating meaningful conversations about Youth United's values."
      }
    ],
    impact: [
      "Increased Youth United's awareness significantly among freshers",
      "Sparked curiosity and drew students into meaningful conversations about social service",
      "Many students expressed interest in joining and signed up before rain brought the fair to an early close",
      "Demonstrated the dedication and teamwork of existing members"
    ]
  },
  3: {
    title: "Orientation Program",
    subtitle: "Question to a Question & Menti Quiz",
    details: {
      date: "1st September, 2025",
      venue: "TAN Building, Room T106, Thapar Campus",
      category: "Community & Onboarding",
      semester: "Odd Semester, Academic Year 2025–26",
      footfall: "~150 participants",
      team: "8 members"
    },
    about: "Youth United held its highly anticipated Orientation Program to welcome new members and introduce them to the vibrant world of the society. The event was carefully designed to be interactive, informative, and inclusive — giving new members a genuine look into the spirit and structure of Youth United.",
    highlights: [
      {
        title: "Icebreaker — \"Question to a Question\"",
        content: "This improvisational challenge required participants to respond only in the form of questions. The game sparked laughter, quick thinking, and high energy, creating a lively and inclusive atmosphere."
      },
      {
        title: "Menti Quiz & Jamming",
        content: "The energy was reignited with a Menti Quiz and concluded with a music jamming session, adding a soulful, relaxed touch and providing a space for self-expression and bonding."
      }
    ],
    impact: [
      "Facilitated a smooth and welcoming transition for new members",
      "Stimulated cognitive agility, teamwork, and inclusivity through activities",
      "Freshers gained a clear and comprehensive understanding of Youth United's mission",
      "Built interpersonal connections between freshers and the Executive Board"
    ]
  },
  4: {
    title: "Air Force Cycle Rally",
    subtitle: "BRD Air Force Cycle Rally — Cycling for a Greener Tomorrow",
    details: {
      date: "13th November, 2025",
      venue: "Thapar Institute of Engineering & Technology",
      category: "Environment",
      semester: "Odd Semester, Academic Year 2025–26",
      participants: "100+",
      team: "20 members"
    },
    about: "The BRD Air Force Cycle Rally was organized by DOSA in collaboration with Youth United Society, Paryavaran Welfare Society, and NCC. The event was a vibrant celebration of recycling, sustainable transport, and environmental cleanliness. Cyclists travelled all the way from Chandigarh to Patiala entirely on bicycles.",
    highlights: [
      {
        title: "Arrival & Interaction",
        content: "Volunteers warmly welcomed cyclists with banners. Brief interaction sessions allowed members to appreciate the cyclists' remarkable effort and share their common passion for environmental protection."
      },
      {
        title: "Visit to the Thapar Recycling Plant",
        content: "Participants rode together to the university's Recycling Plant, offering practical, first-hand insights into waste segregation processes and concrete ways to reduce ecological impact."
      }
    ],
    impact: [
      "Inspired students to consider cycling as a viable eco-friendly alternative",
      "Enhanced awareness of recycling practices and waste segregation",
      "Sparked wider discussions on environmental responsibility through social media",
      "Strengthened partnerships between various campus sustainability organizations"
    ]
  },
  5: {
    title: "Utsav-e-Solace",
    subtitle: "A Donation Drive — A Celebration Carried by Hearts",
    details: {
      date: "27th October – 9th November, 2025",
      category: "Social Impact & Community Service",
      semester: "Odd Semester, Academic Year 2025–26",
      team: "90–100 members",
      engagement: "400+ individuals"
    },
    about: "Youth United, in collaboration with the Rotaract Club of TIET, carried out Utsav-e-Solace — a two-week donation drive campaign rooted in compassion and community action. The initiative embraced the \"Wall of Kindness\" concept, transforming it into a visible symbol of generosity on campus.",
    highlights: [
      {
        title: "The Wall of Kindness",
        content: "A desk was set up daily for residents to drop off donated items. Fun games were also organized to build engagement. Collection points were established at hostels and faculty areas across campus."
      },
      {
        title: "Distribution Day",
        content: "Teams visited Sai Bridh Ashram (Old Age Home), slum areas near the Old Bus Stand, Masti Ki Pathshala (Children's Activity Zone), and Tractor Basti to distribute collected clothes, shoes, and toys."
      }
    ],
    impact: [
      "Raised awareness about local inequalities and the power of small acts of kindness",
      "Created a visible invitation to donate, emphasising reuse and dignity",
      "Provided direct service experience for 100+ student and faculty volunteers",
      "Cultivated a culture of giving and established links with marginalised communities"
    ]
  },
  6: {
    title: "Unity March — Sardar@150",
    subtitle: "Let Us Walk for Unity, Rise for Nation",
    details: {
      date: "17th November, 2025",
      route: "Quila Mubarak Chowk → Kali Mata Mandir, Patiala",
      category: "Unity & Civic Engagement",
      semester: "Odd Semester, Academic Year 2025–26",
      participants: "108"
    },
    about: "The Unity March – Sardar@150 was held to commemorate the 150th birth anniversary of Sardar Vallabhbhai Patel and to promote the message of unity and social responsibility. It was a district-level padyatra organized by MYBharat in partnership with Thapar Institute.",
    highlights: [
      {
        title: "Cultural Program",
        content: "A cultural program at Quila Mubarak Chowk featured Nukkad Natak, dramatic performances by Tamasha Art Group, and energetic Gidda by school students, spreading messages of unity."
      },
      {
        title: "The March",
        content: "Participants covered a 45-minute route to Kali Mata Mandir, carrying banners promoting peace and integrity. The event concluded with a community langar at the temple."
      }
    ],
    impact: [
      "Created a strong sense of togetherness among multiple institutions",
      "Educated students on Sardar Patel's role in unifying India",
      "Spread social messages creatively through cultural performances",
      "Strengthened teamwork and leadership skills among student volunteers"
    ]
  },
  7: {
    title: "Run for Swadeshi",
    subtitle: "Swadeshi Sankalp Run — National Youth Day Celebration",
    details: {
      date: "12th January, 2026",
      venue: "TAN Auditorium + Campus Route, Thapar Institute",
      category: "Youth & National Pride",
      semester: "Even Semester, Academic Year 2025–26",
      participants: "170–180"
    },
    about: "On National Youth Day, commemorating Swami Vivekanand's 164th birth anniversary, Youth United organized the Swadeshi Sankalp Run. The event celebrated self-reliance, youth empowerment, and national pride — values championed by Swami Vivekanand.",
    highlights: [
      {
        title: "Guest Speaker — Dr. Robin Singhla",
        content: "An insightful talk was delivered on Swami Vivekanand's philosophy and vision, inspiring students to embrace self-reliance and national pride before the flag-off."
      },
      {
        title: "The Run",
        content: "The run covered a route through Library Chowk and COS, with students, NCC cadets, and faculty participating enthusiastically. Refreshments and gifts were distributed to all."
      }
    ],
    impact: [
      "Created awareness about the ideals of Swami Vivekanand",
      "Promoted the concept of Swadeshi and youth's role in nation-building",
      "Encouraged physical fitness and social responsibility",
      "Strengthened collaboration between Youth United, NSS, and NCC"
    ]
  },
  8: {
    title: "UMANG 2026",
    subtitle: "A Playground Where Everyone Belongs",
    details: {
      date: "14th February, 2026",
      venue: "K Lawns, Thapar Institute",
      category: "Children & Community",
      semester: "Even Semester, Academic Year 2025–26",
      participants: "152 (including 55 children from Masti Ki Pathshala)"
    },
    about: "UMANG 2026 was a heartwarming celebration for children from Masti Ki Pathshala — a community learning space under a flyover. The day was filled with laughter, games, and shared memories on Thapar's campus, accompanied by a \"Yudh Nasheya Virudh\" anti-drug awareness message.",
    highlights: [
      {
        title: "Mini Game Zone",
        content: "Handcrafted games like Loop, Cup Shot, and a large circular Maze Game were designed by volunteers to encourage teamwork and problem-solving among the children."
      },
      {
        title: "Traditional Games & Creativity",
        content: "Children played Kho-Kho, Pithu, and Dodgeball, followed by face painting and a joyful cake-cutting ceremony with \"Umang 26\" cake."
      }
    ],
    impact: [
      "Provided a joyful space for children to express themselves freely",
      "Broadened children's aspirations by exposing them to a college campus",
      "Developed confidence and teamwork skills through group activities",
      "Reinforced volunteers' commitment to social impact"
    ]
  },
  9: {
    title: "La Fiesta 5.0",
    subtitle: "A Two-Day Celebration of Inclusion, Joy, and Community",
    details: {
      date: "24th–25th April, 2026",
      venue: "Main Auditorium and Fete Area, Thapar Institute",
      category: "Inclusion & Social Impact",
      semester: "Even Semester, Academic Year 2025–26",
      participants: "1500",
      team: "80 members"
    },
    about: "La Fiesta 5.0 was Youth United's flagship two-day celebration, bringing together students from the Deaf and Blind School, Patiala, children from Masti Ki Pathshala and Government High School, Thuhi, and Thapar students. The event combined inclusive activities, entertainment, community participation, and social impact across two venues.",
    highlights: [
      {
        title: "Day One — Inclusive Celebration",
        content: "At the Main Auditorium, children took part in clay modelling, creative play, art activities, an open stage, singing, and other performances. Volunteers created a welcoming environment, and participants received prizes, certificates, gifts, and refreshments."
      },
      {
        title: "Day Two — Carnival at the Fete Area",
        content: "The Fete Area became a carnival with game stalls, challenges, prizes, face painting, photo booths, creative corners, live performances, and a Nukkad Natak by the Nautanki Team. The evening concluded with a light-and-sound show and gift distribution."
      }
    ],
    purpose: "La Fiesta showed how entertainment can create meaningful social connection. By giving children space to participate, express themselves, and feel valued, the event strengthened empathy, inclusion, youth leadership, and community service.",
    impact: [
      "Created a shared platform for children from different communities and Thapar students",
      "Encouraged confidence and self-expression through art, performances, and games",
      "Built compassion and social awareness through direct interaction",
      "Strengthened volunteer teamwork and large-event coordination",
      "Left participants with joyful memories and a lasting message of inclusion"
    ]
  },
  10: {
    title: "STEM Conclave 2026",
    subtitle: "Opening Pathways to Science, Technology, and Innovation",
    details: {
      date: "18th April, 2026",
      venue: "Thapar Institute of Engineering and Technology",
      category: "STEM Education",
      semester: "Even Semester, Academic Year 2025–26",
      time: "9:00 AM–5:00 PM",
      participants: "100 selected girls; 180 total participants recorded",
      team: "65–70 members"
    },
    about: "STEM Conclave 2026 was a day-long student activity track organized by Avanti Fellows and Sanjhi Sikhiya, with volunteer support from Youth United and Pratigya Society. Designed for 100 selected girl students, the conclave offered first-hand exposure to science, technology, engineering, and innovation in a university environment.",
    highlights: [
      {
        title: "Campus Learning Rotations",
        content: "Participants were divided into four groups and followed a planned rotation through the Thapar Library, CSED Department, Mechanical Workshop, and Venture Lab. The schedule allowed every group to explore each activity zone without overcrowding."
      },
      {
        title: "From Engineering Concepts to Practice",
        content: "Students explored Mac labs and coding culture at CSED, observed 3D printing, CNC machines, and foundry processes at the Mechanical Workshop, and built working circuit fans through the Tiny Wires activity at the Venture Lab."
      }
    ],
    purpose: "The conclave made STEM education tangible and inspiring by connecting classroom ideas with modern learning spaces, engineering equipment, coding, and hands-on electronics. It encouraged participants to dream bigger and consider future opportunities in STEM fields.",
    impact: [
      "Provided direct exposure to advanced academic and technical spaces",
      "Built curiosity and practical understanding through guided activities",
      "Helped students connect science and engineering concepts with real applications",
      "Increased confidence and enthusiasm for higher education and STEM careers",
      "Demonstrated the value of organized collaboration between educational and community partners"
    ]
  },
  11: {
    title: "Society Fair 2026",
    subtitle: "Introducing Youth United to the Batch of 2030",
    details: {
      date: "19th August, 2026",
      venue: "FETE Area, Thapar Institute of Engineering & Technology",
      category: "Outreach & Recruitment",
      semester: "Academic Year 2026–27",
      target: "Batch of 2030",
      team: "10 members"
    },
    about: "Youth United participated in Society Fair 2026, organized by Frosh, to introduce its work, initiatives, and activities to the incoming Batch of 2030. The team created an interactive stall combining information, games, creative elements, and direct interaction with students.",
    highlights: [
      {
        title: "Interactive Stall",
        content: "The stall featured Youth United banners, posters, previous-event photographs, games including Dice, Flip the Bottle, Mini Basketball, and Plinko, a photobooth, and handmade decorations."
      },
      {
        title: "Student Engagement",
        content: "Members explained the society's campaigns and opportunities, managed registrations, hosted games, and interacted directly with students. Mini Basketball, Flip the Bottle, and the photobooth attracted strong participation."
      }
    ],
    impact: [
      "Increased Youth United's visibility among the incoming Batch of 2030",
      "Created direct conversations about the society's campaigns and opportunities",
      "Used previous-event displays to communicate Youth United's work",
      "Strengthened team coordination, pitching, stall management, and event execution"
    ]
  },
  12: {
    title: "Orientation Program 2026",
    subtitle: "Welcoming the Batch of 2030",
    details: {
      date: "22nd August, 2026",
      venue: "TAN Auditorium",
      category: "Community & Onboarding",
      semester: "Academic Year 2026–27",
      time: "5:30 PM–7:00 PM",
      target: "Batch of 2030"
    },
    about: "Youth United, Thapar Chapter conducted its 2026 orientation programme to introduce the incoming Batch of 2030 to the society, its work, major events, and departments. The programme combined information, interaction, entertainment, and student participation.",
    highlights: [
      {
        title: "Interactive Introduction",
        content: "A presentation introduced Youth United, its major initiatives, and its departments. A Menti quiz provided an interactive start and kept freshers engaged."
      },
      {
        title: "Performances & Participation",
        content: "The programme included dance, singing, acting, mimicry, and an open opportunity for freshers to perform. It concluded with a Bhangra performance and an open dance session with the incoming students."
      }
    ],
    impact: [
      "Introduced freshers to Youth United's work, initiatives, and departments",
      "Encouraged student participation through the open performance segment",
      "Combined information and entertainment to sustain engagement",
      "Created an energetic and inclusive first interaction with the incoming cohort"
    ]
  }
};
